/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `course` - Kurz * `workshop` - Workshop * `training` - Školení * `seminar` - Seminář * `webinar` - Webinář * `conference` - Konference * `publication` - Publikační / lektorská činnost * `project` - Projektová činnost * `internship` - Stáže / praxe * `self_study` - Samostudium * `volunteering` - Dobrovolnická činnost * `other` - Jiné
 */
export type TeacherActivityActivityTypeEnum = 'course' | 'workshop' | 'training' | 'seminar' | 'webinar' | 'conference' | 'publication' | 'project' | 'internship' | 'self_study' | 'volunteering' | 'other';

export const TeacherActivityActivityTypeEnum = {
    Course: 'course' as TeacherActivityActivityTypeEnum,
    Workshop: 'workshop' as TeacherActivityActivityTypeEnum,
    Training: 'training' as TeacherActivityActivityTypeEnum,
    Seminar: 'seminar' as TeacherActivityActivityTypeEnum,
    Webinar: 'webinar' as TeacherActivityActivityTypeEnum,
    Conference: 'conference' as TeacherActivityActivityTypeEnum,
    Publication: 'publication' as TeacherActivityActivityTypeEnum,
    Project: 'project' as TeacherActivityActivityTypeEnum,
    Internship: 'internship' as TeacherActivityActivityTypeEnum,
    SelfStudy: 'self_study' as TeacherActivityActivityTypeEnum,
    Volunteering: 'volunteering' as TeacherActivityActivityTypeEnum,
    Other: 'other' as TeacherActivityActivityTypeEnum
};